import { Button, Box } from "@mui/material";
import React from "react";

export default function VerifyEmail({ url, tokenMobile, keyMobile }) {
  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  }

  const isWindow = getMobileOperatingSystem() === "Windows Phone";
  const isAndroid = getMobileOperatingSystem() === "Android";
  const isIos = getMobileOperatingSystem() === "iOS";

  const link = isWindow
    ? url
    : isAndroid
    ? `${process.env.REACT_APP_ANDROID_DEEP_LINK_PREFIX}://?token=${tokenMobile}&key=${keyMobile}`
    : isIos
    ? `${process.env.REACT_APP_IOS_DEEP_LINK_PREFIX}://?token=${tokenMobile}&key=${keyMobile}`
    : url;

  return (
    <>
      {/*<Box sx={{ textAlign: "center" }}>
        <Button
          sx={{ width: "200px", my: 5 }}
          onClick={() => {
            window.open(url);
          }}
        >
          Open Travelrite
        </Button>
      </Box>*/}
      <Box sx={{ textAlign: "center" }}>
        <Button sx={{ width: "200px", my: 5 }} href={link} target="_blank">
          Open Travelrite
        </Button>
      </Box>
    </>
  );
}
